// extracted by mini-css-extract-plugin
module.exports = {"h3":"OppositePattern_h3__gb2py","wrapper":"OppositePattern_wrapper__26AAl","arrowsDiv":"OppositePattern_arrowsDiv__2H_8A"};